var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9539 4.56909C23.069 4.95809 22.124 5.22309 21.129 5.34409C22.143 4.73309 22.923 3.77009 23.292 2.62109C22.341 3.17609 21.287 3.58009 20.165 3.80509C19.269 2.84609 17.992 2.24609 16.5739 2.24609C13.857 2.24609 11.6539 4.44909 11.6539 7.16309C11.6539 7.55309 11.699 7.92809 11.781 8.28709C7.69099 8.09409 4.066 6.13009 1.64 3.16109C1.21299 3.88309 0.974 4.72209 0.974 5.63609C0.974 7.34609 1.844 8.8491 3.162 9.73209C2.35499 9.70609 1.596 9.48409 0.934 9.11609V9.17709C0.934 11.5621 2.62699 13.5511 4.88 14.0041C4.46699 14.1151 4.03099 14.1751 3.584 14.1751C3.27 14.1751 2.96899 14.145 2.668 14.089C3.29899 16.0421 5.11299 17.4661 7.272 17.5061C5.592 18.825 3.46299 19.6111 1.17 19.6111C0.78 19.6111 0.391 19.5881 0 19.5441C2.18899 20.9381 4.768 21.753 7.55699 21.753C16.611 21.753 21.556 14.257 21.556 7.76709C21.556 7.55809 21.556 7.34709 21.541 7.13709C22.5019 6.44809 23.341 5.5771 24.001 4.5891L23.9539 4.56909Z",
    fill: "#1C1C33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIns);
export default __webpack_public_path__ + "static/media/ins.f914b8ae67c1aec5de91d5db72393617.svg";
export { ForwardRef as ReactComponent };